import { render } from "./BaseActionLink.vue?vue&type=template&id=ed88cbc2&scoped=true"
import script from "./BaseActionLink.vue?vue&type=script&lang=js"
export * from "./BaseActionLink.vue?vue&type=script&lang=js"

import "./BaseActionLink.vue?vue&type=style&index=0&id=ed88cbc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed88cbc2"]])

export default __exports__